/**
 * Central registry for Stratovai UI automation hooks.
 *
 * Convention: `sv-<area>-<feature>-<surface>` (kebab-case). Prefix `sv-` = Stratovai.
 * Use for interactive surfaces and result regions where role/label selectors are brittle.
 */

export const SV = {
  app: {
    projectSelection: 'sv-app-project-selection',
    projectSearch: 'sv-app-project-search',
    projectGrid: 'sv-app-project-grid',
    projectCard: 'sv-app-project-card',
  },
  nav: {
    item: (navId) => (navId === 'ui-explorer' ? 'sv-nav-ui-explorer' : `sv-nav-${navId}`),
    projectSwitcher: 'sv-nav-project-switcher',
    projectSwitcherStatic: 'sv-nav-project-switcher-static',
    projectSwitcherTrigger: 'sv-nav-project-switcher-trigger',
    projectSwitcherMenu: 'sv-nav-project-switcher-menu',
    projectSwitcherOption: (projectId) => `sv-nav-project-switcher-option-${projectId}`,
  },
  pk: {
    page: 'sv-pk-page',
    tabs: 'sv-pk-tabs',
    tabStaged: 'sv-pk-tab-staged',
    tabApproved: 'sv-pk-tab-approved',
    tabDeleted: 'sv-pk-tab-deleted',
    toolbarRefresh: 'sv-pk-toolbar-refresh',
    toolbarMoveToStaged: 'sv-pk-toolbar-move-to-staged',
    toolbarApproveSelected: 'sv-pk-toolbar-approve-selected',
    toolbarDeleteSelected: 'sv-pk-toolbar-delete-selected',
    toolbarRestoreSelected: 'sv-pk-toolbar-restore-selected',
    search: 'sv-pk-search',
    filtersToggle: 'sv-pk-filters-toggle',
    filterPanel: 'sv-pk-filter-panel',
    table: 'sv-pk-table',
    rowOpenTitle: 'sv-pk-row-open-title',
    rowActionsTrigger: 'sv-pk-row-actions',
    rowActionsMenu: 'sv-pk-row-actions-menu',
    menuViewItem: 'sv-pk-menu-view-item',
    menuJiraReimport: 'sv-pk-menu-jira-reimport',
    menuFigmaReimport: 'sv-pk-menu-figma-reimport',
    menuAnalyzeRequirement: 'sv-pk-menu-analyze-requirement',
    menuImpactedAreas: 'sv-pk-menu-impacted-areas',
    menuGenerateTestCases: 'sv-pk-menu-generate-test-cases',
    menuRegenerateTestCases: 'sv-pk-menu-regenerate-test-cases',
    addKnowledgeOpen: 'sv-pk-add-knowledge-open',
    addDialog: 'sv-pk-add-dialog',
    addTabs: 'sv-pk-add-tabs',
    addTabUpload: 'sv-pk-add-tab-upload',
    addTabPaste: 'sv-pk-add-tab-paste',
    addTabJira: 'sv-pk-add-tab-jira',
    addTabFigma: 'sv-pk-add-tab-figma',
    addTitleField: 'sv-pk-add-title',
    addFileInput: 'sv-pk-add-file-input',
    addBrowseFile: 'sv-pk-add-browse-file',
    addPasteContent: 'sv-pk-add-paste-content',
    addJiraInput: 'sv-pk-add-jira-input',
    addJiraSubmit: 'sv-pk-add-jira-submit',
    addFigmaUrl: 'sv-pk-add-figma-url',
    addFigmaSubmit: 'sv-pk-add-figma-submit',
    addUploadSubmit: 'sv-pk-add-upload-submit',
    addPasteSubmit: 'sv-pk-add-paste-submit',
    addCancel: 'sv-pk-add-cancel',
    figmaConflictDialog: 'sv-pk-figma-conflict-dialog',
    jiraFigmaLoadingDialog: 'sv-pk-jira-figma-loading-dialog',
    documentModal: 'sv-pk-document-modal',
    documentModalContent: 'sv-pk-document-modal-content',
    documentModalClose: 'sv-pk-document-modal-close',
    figmaFrameImage: 'sv-pk-figma-frame-image',
    impactProgressDialog: 'sv-pk-impact-progress-dialog',
    impactModal: 'sv-pk-impact-modal',
    impactModalResults: 'sv-pk-impact-modal-results',
    impactModalClose: 'sv-pk-impact-modal-close',
    requirementAnalysisModal: 'sv-pk-requirement-analysis-modal',
    requirementAnalysisSummary: 'sv-pk-requirement-analysis-summary',
    requirementAnalysisSummaryText: 'sv-pk-requirement-analysis-summary-text',
    requirementAnalysisFindings: 'sv-pk-requirement-analysis-findings',
    requirementAnalysisNoFindingsQuiet: 'sv-pk-requirement-analysis-no-findings-quiet',
    requirementAnalysisQuestions: 'sv-pk-requirement-analysis-questions',
    requirementAnalysisVisual: 'sv-pk-requirement-analysis-visual',
    requirementAnalysisDiagnostics: 'sv-pk-requirement-analysis-diagnostics',
    requirementAnalysisClose: 'sv-pk-requirement-analysis-close',
    reimportLoadingDialog: 'sv-pk-reimport-loading-dialog',
    figmaReimportDialog: 'sv-pk-figma-reimport-dialog',
    figmaReimportProceed: 'sv-pk-figma-reimport-proceed',
    figmaReimportUpdateExisting: 'sv-pk-figma-reimport-update-existing',
    figmaReimportKeepSeparate: 'sv-pk-figma-reimport-keep-separate',
    regenerateTcConfirm: 'sv-pk-regenerate-tc-confirm',
    regenerateTcConfirmAction: 'sv-pk-regenerate-tc-confirm-action',
  },
  chat: {
    root: 'sv-chat-root',
    messages: 'sv-chat-messages',
    input: 'sv-chat-input',
    send: 'sv-chat-send',
    reset: 'sv-chat-reset',
  },
};
